import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DownloadService {

  public downloadBlobAsFile(blob: Blob, fileName: string, fileExtension: string) {
    
    var url = window.URL.createObjectURL(blob);

    var anchor = document.createElement("a");
    anchor.download = fileName + "." + fileExtension;
    anchor.href = url;
    anchor.click();

    anchor.remove();
    window.URL.revokeObjectURL(url);
    return this;
  }

  public copyTextToClipboard(text: string) {

    if (navigator.clipboard) {

      try {
        navigator.clipboard.writeText(text).then(() => {
        }, (error) => {
          throw error;
        });
      } catch (e) {
        console.log(e);
      }

    } else {
      console.log('Browser do not support Clipboard API');
    }

    return this;
    
  }

}